import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {routeKeys} from '#config/routeKeys'

import HorizontalRule from '#components/a/HorizontalRule'
import NumberRow from '#components/m/MeineAusbildung/NumberRow'
import ProgressOverview from '#components/o/MeineAusbildung/ProgressOverview'
import CommentActiveIcon from '#components/svg/icons/CommentActiveIcon'
import NewAufgabeIcon from '#components/svg/icons/NewAufgabeIcon'
import {useNavigate} from "react-router-dom";

export default function Praxisaufgaben(props) {
  const {numbersDashboard, lastModifiedAbteilung, abteilungenWithCommentOrNewAufgabe} = props

  const showEmptyTile = !numbersDashboard || !abteilungenWithCommentOrNewAufgabe

  if (showEmptyTile) {
    return <EmptyTile />
  }

  const navigate = useNavigate()
  function openPraxisaufgaben() {
    navigate(routeKeys.praxisaufgabenOverview)
  }

  function renderReviewedAbteilung(abteilungen) {
    return abteilungen.map((item, index) => {
      const actionIcon = item.aufgabeLastCommentedOn ? <CommentActiveIcon /> : <NewAufgabeIcon />
      return (
        <button
          type="button"
          data-testid="ausbilder-edited-abteilung"
          className="item"
          key={index.toString()}
          onClick={openPraxisaufgaben}
        >
          <span className="icon">{actionIcon}</span>
          {item.name}
        </button>
      )
    })
  }

  function EmptyTile() {
    return (
      <ProgressOverview titleKey="menu_item_praxisaufgabenOverview" showProgressbar={false}>
        <div data-testid="praxisaufgabendashboardNoData" className="praxisaufgaben">
          <span>{i18n.t('loading_dashboard_data_failed')}</span>
        </div>
      </ProgressOverview>
    )
  }

  function sortNumbers(openItems, closedItems) {
    return [
      {
        color: 'green',
        value: closedItems,
        label: 'closed_items',
      },
      {
        color: 'grey',
        value: openItems,
        label: 'open_items',
      },
    ]
  }

  const {openItems, closedItems} = numbersDashboard

  const percentageDone = parseInt((closedItems / (openItems + closedItems)) * 100, 10)
  return (
    <ProgressOverview titleKey="menu_item_praxisaufgabenOverview" percentage={percentageDone}>
      <div data-testid="praxisaufgabendashboard" className="praxisaufgaben">
        <NumberRow modifier="center" numbers={sortNumbers(openItems, closedItems)} />
        <HorizontalRule />
        <span className="title">{i18n.t('last_modified')}</span>

        <div className="in-progress-item">
          {!lastModifiedAbteilung ? (
            <span>{i18n.t('praxisaufgaben_no_finished_task')}</span>
          ) : (
            <button type="button" data-testid="in-progress-abteilung" onClick={openPraxisaufgaben}>
              {lastModifiedAbteilung.name}
              <span className="question-number">{`${lastModifiedAbteilung.tasksDone}/${lastModifiedAbteilung.tasksTotal}`}</span>
            </button>
          )}
        </div>

        <span className="title">{i18n.t('newest_reactions')}</span>
        <div className="reviewed-items">
          {abteilungenWithCommentOrNewAufgabe.length > 0 ? (
            renderReviewedAbteilung(abteilungenWithCommentOrNewAufgabe)
          ) : (
            <span>{i18n.t('praxisaufgaben_no_reviewed_tasks')}</span>
          )}
        </div>
      </div>
    </ProgressOverview>
  )
}

Praxisaufgaben.propTypes = {
  numbersDashboard: PropTypes.shape({
    openItems: PropTypes.number,
    closedItems: PropTypes.number,
  }),
  lastModifiedAbteilung: PropTypes.shape({
    name: PropTypes.string,
    tasksDone: PropTypes.number,
    tasksTotal: PropTypes.number,
  }),
  abteilungenWithCommentOrNewAufgabe: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastAufgabeCreatedOn: PropTypes.string,
      AufgabeLastCommentedOn: PropTypes.string,
    }),
  ),
}
